// import { atom } from 'jotai';
import { atomWithHash } from '@heidi/utils/jotai-helpers';
import { atom } from 'jotai';

export const selectedReviewMemberAtom = atomWithHash<string | undefined>(
  'reviewMember',
  undefined,
  {
    setHash: 'replaceState',
  }
);
export const isInviteModalV2OpenAtom = atom<boolean>(false);
